<template>
  <div class="slotMachine mt-5">
    <!-- <div v-if="checkRoute"  class="d-flex flex-wrap slot-container">
        <div  class="slot" v-for="(slot, index) in slots" ref="slots" v-bind:key="index">
          <h2>{{ slot.digit }}</h2>
            <v-card class="slot__window d-flex justify-center">
              <div class="slot__wrap text-color">
                <div class="slot__item no-kado " v-for="(opt, idx) in list_kado" v-bind:key="idx">{{ opt }}</div>
                <div class="slot__item slot__item--copy ">{{ list_kado[0] }}</div>
              </div>
            </v-card>
        </div>
      </div> -->

    <div class="d-flex flex-wrap slot-container">
      <v-btn
        @click="checkData"
        color="mainPink"
        class="calmWhite--text"
        style="position: absolute; top: 5vh"
        >SLOT DOORPRIZE NIH</v-btn
      >
      <div v-if="isLoading">
        <h2>LOADING...</h2>
      </div>
      <div
        v-else
        class="slot"
        v-for="(slot, index) in +doorprizes.qty"
        ref="slots"
        v-bind:key="index"
      >
        <!-- <h2>{{ slot.id }}</h2> -->
        <v-card class="slot__window d-flex justify-center">
          <div
            v-if="spinning || doorprizes_winners.length !== 0"
            class="slot__wrap text-color"
          >
            <div
              class="slot__item no-kado"
              v-for="(opt, idx) in getDigitPerson"
              v-bind:key="idx"
            >
              {{ opt.digits }}
            </div>
            <div class="slot__item slot__item--copy">
              {{ getDigitPerson[0].digits }}
            </div>
          </div>
          <div v-else class="slot__wrap text-color">
            <div
              class="slot__item no-kado"
              v-for="(opt, idx) in getDigitPerson"
              v-bind:key="idx"
            >
              ?
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { useSound } from "@vueuse/sound";
import slotSfx from "../../assets/slot-sound.mp3";

const next =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  function (cb) {
    window.setTimeout(cb, 1000 / 60);
  };

export default {
  data() {
    return {
      spinning: false,
      digits: [],
      gifted_kado: [],
      doorprizes_winners: [],
      opts: null,
      startedAt: null,
    };
  },
  props: ["typeSlot", "items"],
  setup() {
    //  const slotSound = useSound(slotSfx, {volume: 0.5})
    return {
      //  slotSound
    };
  },
  created() {
    this.$store.dispatch("getPersonDoorprize");
    // consoole.log(this.doorprizes, "< dp")
    // this.$store.dispatch('getDoorprize', this.$route.params.id)
  },
  computed: {
    ...mapState({
      slots: (state) => state.slotMachine.slots,
      list_kado: (state) => state.slotMachine.list_kado,
      doorprizes: (state) => state.slotDoorprize.gifts,
      // person: state => state.getters.person.map(item => item.digits).sort(() => 0.5 - Math.random()).slice(0, 16),
      isLoading: (state) => state.slotMachine.isLoading,
    }),
    ...mapGetters(["getDigitPerson"]),
    checkRoute() {
      return this.$route.name == "Slot";
    },
  },
  methods: {
    checkData() {
      // console.log(this.getDigitPerson,  "< data di slot machine")
      // const digits = this.slots.map(item => item.digit)
      this.start();
    },
    start: function () {
      if (this.opts) {
        return;
      }
      this.spinning = true;
      var randomIndex = [];
      if (this.$route.name !== "Slot") {
        while (randomIndex.length < this.getDigitPerson.length) {
          var r = Math.floor(Math.random() * this.getDigitPerson.length);
          if (randomIndex.indexOf(r) === -1) randomIndex.push(r);
        }
      } else {
        while (randomIndex.length < this.list_kado.length) {
          var r = Math.floor(Math.random() * this.list_kado.length);
          if (randomIndex.indexOf(r) === -1) randomIndex.push(r);
        }
      }

      // console.log(this.$refs.slots, this.doorprizes, "<< slot data")
      this.opts = this.getDigitPerson.map((data, i) => {
        const slot = this.$refs.slots[i];
        // console.log(slot)
        // slot.querySelector('.text-color').style.color = "#" + Math.floor(Math.random() * 16777215).toString(16);;
        const opts = {
          el: slot.querySelector(".slot__wrap"),
          finalPos: randomIndex[i] * 80,
          startOffset: 2000 + Math.random() * 500 + i * 500,
          height:
            this.$route.name === "Slot"
              ? this.list_kado.length * 120
              : this.getDigitPerson.length * 120,
          duration: 1000 + i * 500, // milliseconds
          isFinished: false,
        };

        if (this.$route.name === "Slot") {
          console.log("masdhasdasda ==========");

          this.gifted_kado.push({
            digit: data.digit,
            get_kado: this.list_kado[randomIndex[i]],
          });
        }
        this.doorprizes_winners.push(data.userId);

        // update di db status kado pemilik telah diberikan
        return opts;
      });

      // console.log("spinning..", this.spinning)

      next(this.animate);
      if (this.$route.name === "Slot") {
        this.$store.dispatch("updateDataKado", this.gifted_kado);
      } else {
        console.log("DOORPRIZE SELESAI", this.doorprizes_winners);
        this.$store.dispatch("updateDataDoorprize", {
          prizeId: this.doorprizes.id,
          winners: this.doorprizes_winners,
        });
      }
    },

    animate: function (timestamp) {
      if (this.startedAt == null) {
        this.startedAt = timestamp;
      }
      const timeDiff = timestamp - this.startedAt;

      this.opts.forEach((opt) => {
        if (opt.isFinished) {
          return;
        }

        const timeRemaining = Math.max(opt.duration - timeDiff, 0);
        const power = 3;
        const offset =
          (Math.pow(timeRemaining, power) / Math.pow(opt.duration, power)) *
          opt.startOffset;

        // negative, such that slots move from top to bottom
        const pos = -1 * Math.floor((offset + opt.finalPos) % opt.height);

        opt.el.style.transform = "translateY(" + pos + "px)";

        if (timeDiff > opt.duration) {
          // console.log('finished', opt, pos, opt.finalPost)
          opt.isFinished = true;
        }
      });

      if (this.opts.every((o) => o.isFinished)) {
        this.opts = null;
        this.startedAt = null;
        this.spinning = false;
        if (!this.spinning) {
          // console.log(this.gifted_kado, "<< data gifted kado")
          // console.log(gifted_kado)
          setTimeout(() => {
            this.$store.dispatch(
              "updatePersonDoorprize",
              this.doorprizes_winners
            );
          }, 2000);
        }
        // console.log(this.spinning, "<< spinning dari parenr")
        this.gifted_kado = [];
      } else {
        next(this.animate);
      }
    },
  },
};
</script>

<style>
/* @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap'); */

.slot {
  margin: 10px 12px;
}

.slot__window {
  background-color: rgb(104, 155, 104);
  width: 100px;
  height: 100px;
  overflow: hidden;
}

.slot__wrap {
}

.slot__item {
  margin-top: 20px;
  height: 60px;
  width: 100px;
  padding: 0 10px;

  /* font-family: 'Press Start 2P', cursive; */
  font-size: 24px;
  text-align: center;

  line-height: 60px;
}

.slot__item--copy {
}

.slot-container {
  margin: auto 12px;
  justify-content: center;
}
.no-kado {
}
</style>
